import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

type TTooltip = {
  text: string;
};
type TTTooltip = {
  text: string;
  show: boolean;
  children?: ReactNode;
};

const TooltipWrapper = styled.span(
  ({ theme }) => css`
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.35s ease;
    opacity: 0;
    visibility: hidden;
  `
);

const Msg = styled.div(
  ({ theme }) => css`
    border-radius: 5px;
    text-align: center;
    width: 151px;
    background-color: ${theme.colors.white};
    font-size: ${theme.fonts.sizes.h6};
    border: 1px solid ${theme.colors.warmGrey};
  `
);

const HoverTooltipMsg = styled.span(
  ({ theme }) => css`
    visibility: hidden;
    width: 151px;
    background-color: ${theme.colors.tooltip.background};
    font-size: ${theme.fonts.sizes.h6};
    border: 1px solid ${theme.colors.tooltip.border};
    color: ${theme.colors.tooltip.text};
    box-shadow: ${theme.colors.tooltip.boxShadow};
    pointer-events: none;
    border-radius: 8px;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0.4375rem 0.625rem;
    position: absolute;
    z-index: 1;
  `
);

const HoverTooltipWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    .tooltiptext {
      visibility: hidden;
    }
    > * {
      width: 100%;
    }
    @media (hover: hover) {
      &:hover {
        .tooltiptext {
          visibility: visible;
        }
      }
    }
  `
);
export const HoverTooltip = ({ text, show, children }: TTTooltip) => {
  if (show) {
    return (
      <HoverTooltipWrapper className="tooltip">
        <HoverTooltipMsg className="tooltiptext">{text}</HoverTooltipMsg>
        {children}
      </HoverTooltipWrapper>
    );
  }
  return <>{children}</>;
};
export const Tooltip = ({ text }: TTooltip) => {
  return (
    <TooltipWrapper>
      <Msg>{text}</Msg>
    </TooltipWrapper>
  );
};

const HelpTooltipComponent = styled.span(
  ({ theme }) => css`
    cursor: help;
    opacity: 0.4;
    font-color: ${theme.colors.gray};
    font-size: 1.25rem;
    margin: -0.25rem 0.5rem 0;
  `
);

export const HelpTooltip = ({ text }: TTooltip) => {
  return (
    <HelpTooltipComponent className={'material-symbols-rounded'} title={text}>
      help
    </HelpTooltipComponent>
  );
};
